import * as React from "react";
import { Button } from "@/components/ui/button";
import { RefreshCw, ChevronUp, ChevronDown } from "lucide-react";
import { cn } from "@/lib/utils";

interface PlaceholderControlProps {
  count: number;
  currentIndex: number;
  onRefresh: () => void;
  isRefreshing: boolean;
  onNavigateNext: () => void;
  onNavigatePrevious: () => void;
}

const PlaceholderControl: React.FC<PlaceholderControlProps> = ({
  count,
  currentIndex,
  onRefresh,
  isRefreshing,
  onNavigateNext,
  onNavigatePrevious
}) => {
  if (count === 0) {
    return (
      <div className="h-9 border border-gray-200 rounded-md px-3 bg-gray-50 flex items-center gap-2 whitespace-nowrap">
        <span className="text-xs text-gray-600">
          <span className="font-medium text-gray-900">0</span> placeholders
        </span>
        <Button
          variant="ghost"
          size="sm"
          onClick={onRefresh}
          disabled={isRefreshing}
          className="h-6 w-6 p-0 text-gray-600 hover:text-gray-900"
          title="Refresh counter"
        >
          <RefreshCw
            className={cn("w-3 h-3", isRefreshing && "animate-spin")}
          />
        </Button>
      </div>
    );
  }

  return (
    <div className="h-9 border border-gray-200 rounded-md px-2 bg-gray-50 flex items-center gap-2">
      {/* Info */}
      <span className="text-xs text-gray-700 font-medium whitespace-nowrap">
        {currentIndex + 1}/{count}
      </span>

      {/* Refresh */}
      <Button
        variant="ghost"
        size="sm"
        onClick={onRefresh}
        disabled={isRefreshing}
        className="h-6 w-6 p-0 text-gray-600 hover:text-gray-900"
        title="Refresh"
      >
        <RefreshCw
          className={cn("w-3 h-3", isRefreshing && "animate-spin")}
        />
      </Button>

      {/* Separador */}
      <div className="h-4 w-px bg-gray-300" />

      {/* Navegación */}
      <div className="flex gap-0.5">
        <Button
          variant="ghost"
          size="sm"
          onClick={onNavigatePrevious}
          title="Previous placeholder"
          className="h-6 w-6 p-0 hover:bg-gray-200"
        >
          <ChevronUp className="h-3.5 w-3.5" />
        </Button>
        <Button
          variant="ghost"
          size="sm"
          onClick={onNavigateNext}
          title="Next placeholder"
          className="h-6 w-6 p-0 hover:bg-gray-200"
        >
          <ChevronDown className="h-3.5 w-3.5" />
        </Button>
      </div>
    </div>
  );
};

export default PlaceholderControl;

